var _ellipse, _ellipse2, _path, _ellipse3, _ellipse4, _path2, _path3, _path4, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 44,
    viewBox: "0 0 37 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5001,
    cy: 25.5,
    rx: 14.5,
    ry: 18.5,
    fill: "#69BE7F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5001,
    cy: 26,
    rx: 11.5,
    ry: 15,
    fill: "#94CCA3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 20C13.8808 20 15.0001 21.3431 15.0001 23C15.0001 24.6569 13.8808 26 12.5001 26C11.1194 26 10.0001 24.6569 10.0001 23C10.0001 21.3431 11.1194 20 12.5001 20ZM23.5001 20C24.8808 20 26.0001 21.3431 26.0001 23C26.0001 24.6569 24.8808 26 23.5001 26C22.1194 26 21.0001 24.6569 21.0001 23C21.0001 21.3431 22.1194 20 23.5001 20Z",
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.0001,
    cy: 21.5,
    rx: 1,
    ry: 1.5,
    fill: "#D9D9D9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0001,
    cy: 21.5,
    rx: 1,
    ry: 1.5,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4664 9.75534L9.57847 6.11778C8.22958 4.41879 6.36479 3.20451 4.26538 2.6581L1.94533 2.05428",
    stroke: "#69BE7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2489 9.40717L27.1369 5.76961C28.4858 4.07061 30.3505 2.85633 32.45 2.30993L34.77 1.7061",
    stroke: "#69BE7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 30C16.1477 31.5738 19.8525 31.5738 23.0001 30",
    stroke: "black",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 1.5,
    r: 1.5,
    fill: "#69BE7F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#69BE7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorm);
export default __webpack_public_path__ + "static/media/worm.c4c239987836209152a73ef3f660fa3f.svg";
export { ForwardRef as ReactComponent };